// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"X3-z","dimensionLabel":"Y3-z","styleChooserControlWrapper":"Z3-z","styleChooserControl":"_3-z","disabled":"a4-z","giftCard":"b4-z","styleChooserText":"c4-z"};